import { Button, Col, Form, Input, notification, Popconfirm, Row, Select, Spin, Switch, Table, TimePicker } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { addDietTimeApi, listOfDietTimeApi, listOfMealTimeApi, updateDietTimeApi } from "../../../../../config/Api";
import { API_ERR_MESSAGE } from "../../../../../config/constant";
export const DietTime = () => {
    const { Option } = Select;
    const [dietTypes, setDietTypes] = useState('')
    const [detail, setDetail] = useState('')

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [mealTimeOptionList, setMealTimeOptionList] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [dietTimeData, setDietTimeData] = useState()
    const [editDietTimeRecord, setEditDietTimeRecord] = useState()
    const [loading, setLoading] = useState(false)

    // get the list of alll available plans 
    const getListOfMealTime = () => {
        setLoading(true)
        listOfMealTimeApi()
            .then((res) => {
                if (res.status === 200) {
                    setMealTimeOptionList(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }


    // get the list of alll available Meal Times
    const getListOfDietTimes = () => {
        setLoading(true)
        listOfDietTimeApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // call when user click on edit
    const editBpTypes = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'time': data.time })
        form.setFieldsValue({ 'types': data.meal_time_id })
        setEditDietTimeRecord(data);
    }

    useEffect(() => {
        getListOfDietTimes()
        getListOfMealTime()
    }, []);

    // filter data according to user search input 
    useEffect(() => {
        filterDietTime(dietTimeData);
    }, [dietTimeData]);

    // filter recipe tags
    const filterDietTime = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            // console.log("dataSource", dataSource);
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.time.toUpperCase().indexOf(data.toUpperCase()) !== -1 || element.meal_time.name.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // update status of recipe category
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateDietTimeApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Diet Time Update successfully",
                    });
                    getListOfDietTimes()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    const columns = [
        {
            title: 'Time',
            dataIndex: 'time',
            key: 'time',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Meal Time',
            dataIndex: 'meal_time',
            key: 'meal_time',
            render: (text, data) => <a>{data?.meal_time?.name}</a>,
            // filters: [
            //     { text: "Breakfast", value: "Breakfast" },
            //     { text: "Mid", value: "Mid" },
            //     { text: "Lunch", value: "Lunch" },
            //     { text: "Evening", value: "Evening" },
            //     { text: "Dinner", value: "Dinner" },
            // ],
            // onFilter: (value, record) => record.dietType == value,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editBpTypes(record) }} className="me-2" />
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            time: '8:00 AM to 9:00 AM',
            dietType: 'Breakfast',
            status: true
        },
        {
            id: '2',
            time: '10:00 AM to 11:00 AM',
            dietType: 'Mid Morning',
            status: false
        },
        {
            id: '3',
            time: '1:00 PM to 2:00 PM',
            dietType: 'Lunch',
            status: true
        },
        {
            id: '4',
            time: '5:00 PM to 6:00 PM',
            dietType: 'Evening',
            status: true
        },
        {
            id: '5',
            time: '8:00 PM to 9:00 PM',
            dietType: 'Dinner',
            status: true
        },
    ];

    const [form] = Form.useForm();
    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "time": values.time,
                "meal_time_id": values.types,
                "status": true
            }
            addDietTimeApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'types': '' })
                        form.setFieldsValue({ 'time': '' })
                        notification.success({
                            message: "Diet Time added successfully",
                        });
                        getListOfDietTimes()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "time": values.time,
                "meal_time_id": values.types,
                "status": values.status
            }
            updateDietTimeApi(editDietTimeRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Diet Time Update successfully",
                        });
                        getListOfDietTimes()
                        form.setFieldsValue({ 'types': '' })
                        form.setFieldsValue({ 'time': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };
    const resetData = () => {
        form.resetFields()
    };

    return (
        <div className="DietTime">
            <Row>
                <Col xl={14}>
                    <Form
                        name="AddDietTimeForm"
                        className="AddDietTimeForm"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row>
                            <Col xl={8}>
                                <Form.Item
                                    name="types"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select Diet Time!",
                                        },
                                    ]}
                                    initialValue=""
                                >
                                    <Select
                                        // value={regType}
                                        onChange={(e) => setDietTypes(e)}
                                    >
                                        <Option value="" disabled hidden>
                                            Select Meal Time
                                        </Option>
                                        {
                                            mealTimeOptionList && mealTimeOptionList.length > 0 && mealTimeOptionList.map((option, index) =>
                                                <Option value={option.id}>{option.name}</Option>
                                            )
                                        }
                                        {/* <Option value="Mid Morning">Mid Morning</Option>
                                        <Option value="Lunch ">Lunch </Option>
                                        <Option value="Evening">Evening</Option>
                                        <Option value="Dinner ">Dinner </Option> */}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xl={8} className="ms-1">
                                <Form.Item
                                    name="time"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter details!",
                                        },
                                    ]}
                                >
                                    <Input placeholder="Enter details" className="p-2" onChange={(e) => setDetail(e.target.value)} />
                                </Form.Item>
                            </Col>

                            <Col xl={7}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2" icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}>
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>

                    </Form>

                </Col>
                <Col xl={4} className="text-end align-self-center">
                    {/* <h6>{tagCategory ?  `Total ${tagCategory}` : "Total Tags"  }</h6> */}
                    <h6> Total :  {displayData.length > 0 ? displayData.length : 0}   </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Meal Time"
                        onChange={(e) => { filterDietTime(e.target.value); setDietTimeData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        rowKey="id"
                        dataSource={displayData}
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div>
    )
}
